import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { RcsMessage, MessageType } from '../../../../../../_models/messaging/messages/rcs-messages/rcs-message.model';
import { ValidationService } from '../../../../../../_services/messaging/messages/rcs-messages/validation.service';

@Component({
  selector: 'app-rcs-sms',
  templateUrl: './rcs-sms.component.html',
  styleUrls: ['./rcs-sms.component.scss']
})
export class RcsSmsComponent implements OnInit {
  @Input() message: RcsMessage | null = null;
  @Output() messageChange = new EventEmitter<RcsMessage>();
  
  smsText: string = '';
  textError: string = '';
  Math = Math;

  constructor(private validationService: ValidationService) {}

  ngOnInit(): void {
    if (this.message?.smsText) {
      this.smsText = this.message.smsText;
    }
  }

  onTextChange(): void {
    this.validateText();
    this.updateMessage();
  }

  validateText(): void {
    this.textError = '';
    const profanityCheck = this.validationService.validateTextForProfanity(this.smsText);
    if (!profanityCheck.valid) {
      this.textError = profanityCheck.error || '';
      return;
    }
  }

  updateMessage(): void {
    const updatedMessage: RcsMessage = {
      type: MessageType.SMS,
      smsText: this.smsText,
      timestamp: new Date()
    };
    this.messageChange.emit(updatedMessage);
  }
}

